import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiMutationHook } from '../../../common/queryClient/createApiMutationHook';
import {
  InsertDraftsResponseSchema,
  InsertDraftsResponseType,
} from '../../../edit-session';
import { InputDataEditSessionUrl } from '../InputDataEditSessionUrl';

interface InsertInputDataDraftRequest {
  sessionId: string;
  payloads: unknown[];
}

const insertInputDataDraft = async ({
  sessionId,
  payloads,
}: InsertInputDataDraftRequest): Promise<InsertDraftsResponseType> =>
  apiClient
    .patch(expand(InputDataEditSessionUrl.rows, { sessionId }), {
      drafts: payloads.map((payload) => {
        return {
          op: 'INSERT',
          payload,
        };
      }),
    })
    .then((response) => response.data)
    .then(InsertDraftsResponseSchema.parse);

export const useInsertInputDataDraftMutation = createApiMutationHook<
  InsertInputDataDraftRequest,
  InsertDraftsResponseType
>(['input-data-draft-insert'], insertInputDataDraft);
